import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import svguri from "./svguri";
var DEFAULT_SIZE = 32;
var IconWrapper = styled.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "sc-11n082z-0"
})(["display:inline-block;background:center/contain no-repeat url(\"", "\");width:", "px;height:", "px;"], function (_ref) {
  var icon = _ref.icon;
  return icon;
}, function (_ref2) {
  var width = _ref2.width;
  return width;
}, function (_ref3) {
  var height = _ref3.height;
  return height;
});

var Icon = function Icon(_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? DEFAULT_SIZE : _ref4$size,
      _ref4$width = _ref4.width,
      width = _ref4$width === void 0 ? size : _ref4$width,
      _ref4$height = _ref4.height,
      height = _ref4$height === void 0 ? size : _ref4$height,
      className = _ref4.className,
      icon = _ref4.icon;
  return /*#__PURE__*/React.createElement(IconWrapper, {
    className: className,
    width: width,
    height: height,
    icon: icon,
    role: "presentation"
  });
};

Icon.svguri = svguri;
Icon.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.string.isRequired
} : {};
export default Icon;
//# sourceMappingURL=Icon.js.map